import { connect } from 'react-redux';
import {
  fetchReservationPending,
  updateReservationStatus,
  unlinkReservation
} from '../../../redux/Reservation/sagas/routines';
import {
  getIsFetching,
  getIsSaving,
  getOrder
} from '../../../redux/Reservation/selectors/pending';
import {
  clearReservationPending,
  reservationPendingOnChangePage,
  reservationPendingOnChangeOrder
} from '../../../redux/Reservation/actions/pending';
import {
  getPaginationLoadedPages,
  getPaginationWithoutPages,
  getPaginationQueryOptions,
  getCurrentPageItems
} from '../../../redux/Reservation/selectors/pending/pagination';
import { getSearchQueryForContext } from '../../../redux/Reservation/selectors/components/search';
import SEARCH_CONTEXT from '../../../constants/reservation/SearchContext';
import { APPROVE, REJECT } from '../../../constants/reservation/StatusActions';
import ReservationList from '../../../components/reservations/List';
import mergeListQueries from '../../../helpers/mergeListQueries';
import orderList from '../../../helpers/reservationOrderList';
import {
  setReservationsSearchQueryCookie,
  getReservationsSearchQueryCookie,
  getReservationsRememberFlagCookie
} from '../../../services/currentUserCookie';
import { hasPortalFeature } from '../../../helpers/config';
import { fetchSmtpAccounts } from '../../../redux/Settings/sagas/portal/smtp-account/routines';
import { SMTP_TYPES } from '../../../constants/smtp-account';
import { getHasActiveSmtpAccount } from '../../../redux/Settings/selectors/portal/smtp-account';

const context = SEARCH_CONTEXT.PENDING;

function mapStateToProps(state) {
  const paginationQuery = getPaginationQueryOptions(state);
  const searchQuery = getSearchQueryForContext(state, context);
  const order = getOrder(state);
  const isUseQueryCookie = getReservationsRememberFlagCookie(context);
  const query = isUseQueryCookie
    ? getReservationsSearchQueryCookie(context)
    : mergeListQueries(paginationQuery, searchQuery, order);

  return {
    query,
    items: orderList(order, getCurrentPageItems(state)),
    loadedPages: getPaginationLoadedPages(state),
    pagination: getPaginationWithoutPages(state),
    isNotifyGuestEnabled: hasPortalFeature,
    isFetching: getIsFetching(state),
    isSaving: getIsSaving(state),
    hasActiveSmtpAccounts: getHasActiveSmtpAccount(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: query => {
      dispatch(fetchReservationPending(query || {}));
      dispatch(fetchSmtpAccounts({ type: SMTP_TYPES.GMAIL }));
    },
    onChangePage: (query, isPageLoaded) => {
      const { page } = query;
      if (!isPageLoaded) dispatch(fetchReservationPending(query));
      else dispatch(reservationPendingOnChangePage(page));

      const isUseQueryCookie = getReservationsRememberFlagCookie(context);
      if (isUseQueryCookie) {
        setReservationsSearchQueryCookie(context, query);
      }
    },
    onChangeLimit: query => {
      dispatch(clearReservationPending());
      dispatch(fetchReservationPending(query));

      const isUseQueryCookie = getReservationsRememberFlagCookie(context);
      if (isUseQueryCookie) {
        setReservationsSearchQueryCookie(context, query);
      }
    },
    onSort: (sortBy, sortOrder, query) => {
      const order = `${sortBy}:${sortOrder}`;
      const updatedQuery = { ...query, order };
      dispatch(clearReservationPending());
      dispatch(fetchReservationPending(updatedQuery));
      dispatch(reservationPendingOnChangeOrder(order));

      const isUseQueryCookie = getReservationsRememberFlagCookie(context);
      if (isUseQueryCookie) {
        setReservationsSearchQueryCookie(context, updatedQuery);
      }
    },
    onApprove: (id, notifyGuest = false, email = null) => {
      const body = { notifyGuest, email };
      dispatch(updateReservationStatus({ id, body, statusAction: APPROVE }));
    },
    onReject: (id, notifyGuest = false, email = null) => {
      const body = { notifyGuest, email };
      dispatch(updateReservationStatus({ id, body, statusAction: REJECT }));
    },
    onUnlink: (id, body) => {
      dispatch(unlinkReservation({ id, body }));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReservationList);
